import React from 'react';
import { useAppStore } from '@/store/loadingStore';
import { GlobalLoading } from '@/components/ui/common/loading/GlobalLoading';

export const GlobalLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoading, message, progress, showCancelButton, onCancel } = useAppStore();

  return (
    <>
      {children}
      <GlobalLoading
        isVisible={isLoading}
        message={message}
        progress={progress}
        showCancelButton={showCancelButton}
        onCancel={onCancel || undefined}
      />
    </>
  );
};
